<template>
  <div class="section">
    <div class="row">
      <div class="name">用户ID：</div>
      <div class="label">{{ user.id }}</div>
    </div>
    <div class="col-group">
      <div class="col">
        <div class="name">真实姓名：</div>
        <div class="label" v-if="user.username">
          <Input
            class="height45"
            disabled
            type="text"
            v-model="user.username"
            placeholder="请输入转入的域名"
            clearable
          ></Input>
        </div>
        <div class="label" v-else>
          <router-link to="/user/account/certified"
            >未实名认证，请前往认证</router-link
          >
        </div>
      </div>
      <div class="col">
        <div class="name required">昵称：</div>
        <div class="label">
          <Input
            class="height45"
            type="text"
            v-model="form.nickname"
            placeholder="请输入昵称"
            style="width: 200px"
            clearable
          ></Input>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="name required">性别：</div>
      <div class="label">
        <RadioGroup v-model="form.sex">
          <Radio :label="0"> 男</Radio>
          <Radio :label="1"> 女</Radio>
        </RadioGroup>
      </div>
    </div>
    <div class="col-group">
      <div class="col">
        <div class="name">出生日期：</div>
        <DatePicker
          class="height45"
          v-model="form.birthday"
          @on-change="handleChange"
          type="date"
          format="yyyy-MM-dd"
          placeholder="请输入出生日期"
          style="width: 200px"
          clearable
        ></DatePicker>
      </div>
      <div class="col">
        <div class="name">联系电话：</div>
        <div class="label">
          <Input
            class="height45"
            disabled
            type="text"
            v-model="user.phoneNumber"
            placeholder="请输入联系电话"
            style="width: 200px"
            clearable
          ></Input>
        </div>
      </div>
    </div>
    <div class="col-group">
      <div class="col">
        <div class="name">联系QQ：</div>
        <Input
          class="height45"
          type="text"
          v-model="form.qq"
          placeholder="请输入联系QQ"
          style="width: 200px"
          clearable
        ></Input>
      </div>
      <div class="col">
        <div class="name">微信号：</div>
        <div class="label t-row">
          <Input
            class="height45"
            type="text"
            v-model="form.wechat"
            placeholder="请输入微信号"
            style="width: 200px"
            clearable
          ></Input>
          <Button
            style="margin-left: 20px"
            v-if="form.wechatImg"
            @click="showWechat"
            >查看微信头像</Button
          >
          <Upload
            class="upload"
            style="margin-left: 20px; border: none"
            type="drag"
            :before-upload="handleBeforeUpload"
            :show-upload-list="false"
            action="/"
          >
            <Button>添加微信头像</Button>
          </Upload>
        </div>
      </div>
    </div>
    <div class="col-group">
      <div class="col">
        <div class="name required">省份-城市：</div>
        <Select
          class="height45"
          v-model="form.province"
          filterable
          style="margin-right: 10px; width: 120px"
          @on-change="changeProvince"
        >
          <Option
            v-for="(item, index) in areas"
            :key="'p' + index"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Select
          class="height45"
          v-if="form.province != null && form.province != ''"
          v-model="form.city"
          style="margin-right: 10px; width: 120px"
          filterable
        >
          <Option
            v-for="item in cityList"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>
      <div class="col">
        <div class="name">联系地址：</div>
        <div class="label">
          <Input
            class="height45"
            type="text"
            v-model="form.address"
            placeholder="请输入联系地址"
            style="width: 200px"
            clearable
          ></Input>
        </div>
      </div>
    </div>
    <div class="col-group">
      <div class="col">
        <div class="name">邮政编码：</div>
        <div class="label">
          <Input
            class="height45"
            type="text"
            v-model="form.postcode"
            placeholder="请输入邮政编码"
            style="width: 200px"
            clearable
          ></Input>
        </div>
      </div>
      <div class="col">
        <div class="name">传真号码：</div>
        <div class="label">
          <Input
            class="height45"
            type="text"
            v-model="form.fax"
            placeholder="请输入传真号码"
            style="width: 200px"
            clearable
          ></Input>
        </div>
      </div>
    </div>
    <Button
      :loading="loading"
      style="height: 45px; width: 100px"
      type="primary"
      @click="onConfirm"
      >确认修改</Button
    >
    <!-- 查看头像 -->
    <userImageModal
      :show.sync="userImageModalVisibility"
      :data="form.wechatImg"
    ></userImageModal>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import userImageModal from "components/account/userImageModal.vue";
import { userEdit, uploadPicture } from "api/user.js";
import { getRegionList } from "api/domain.js";

export default {
  name: "account",
  components: {
    userImageModal,
  },
  data() {
    return {
      form: {
        nickname: "",
        sex: 0,
        birthday: "",
        qq: "",
        wechat: "",
        province: "",
        city: "",
        area: "",
        address: "",
        postcode: "",
        fax: "",
        wechatImg: "",
        file: "",
      },
      format: "yyyy-MM-dd",
      areaList: [],
      cityList: [],
      loading: false,
      userImageModalVisibility: false,
    };
  },
  computed: {
    ...mapState(["user", "areas"]),
  },
  async created() {
    if (this.areas.length === 0) {
      await this.req_getRegionList();
    }
    this.valueData();
  },
  methods: {
    ...mapActions(["ACT_REGION_LIST"]),
    ...mapMutations(["MUT_USER_PART_INFO", "MTU_REGION_LIST"]),
    valueData() {
      this.form.nickname = this.user.nickname;
      this.form.sex = this.user.sex;
      this.form.birthday = this.user.birthday;
      this.form.qq = this.user.qq;
      this.form.wechat = this.user.wechat;
      this.form.province = this.user.province;
      this.form.area = this.user.area;
      this.form.address = this.user.address;
      this.form.postcode = this.user.postcode;
      this.form.fax = this.user.fax;
      this.form.wechatImg = this.user.wechatImg;

      if (this.form.province) {
        this.changeProvince();
        this.form.city = this.user.city;
      }
    },
    // 选择图片后处理
    handleBeforeUpload(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg"
      ) {
        this.$Message.warning("图片要求上传jpg或者png格式或者jpeg格式");
        return false;
      }
      this.form.file = file;
      this.form.wechatImg = window.URL.createObjectURL(file);
      this.$Message.success("微信图片添加成功，记得点击确认进行保存哦！");
      return false;
    },
    // 省改变
    changeProvince() {
      let selectArray = this.areas.filter(
        (o) => o.value === this.form.province
      );
      this.cityList = selectArray[0].children;
      this.form.city = "";
    },
    // 查看微信头像
    showWechat() {
      this.userImageModalVisibility = true;
    },
    // 时间变化
    handleChange(val) {
      this.form.birthday = val;
    },
    // 确认
    async onConfirm() {
      try {
        if (!this.form.nickname) {
          this.$Message.warning("请输入昵称！");
          return;
        }
        if (!this.form.province || !this.form.city) {
          this.$Message.warning("请选择省份-城市！");
          return;
        }
        this.loading = true;
        if (this.form.file) {
          const formData = new FormData();
          formData.append("file", this.form.file);
          const res = await uploadPicture(formData);
          if (res.code === 200 && res.result) {
            this.form.wechatImg = res.data.url;
          } else {
            this.loading = false;
            return;
          }
        }
        if(this.form.birthday instanceof Date){
          this.form.birthday = this.form.birthday.pattern('yyyy-MM-ddd');
        }
      
        const params = {
          address: this.form.address,
          area: this.form.area,
          birthday: this.form.birthday,
          city: this.form.city,
          email: this.form.email,
          fax: this.form.fax,
          nickname: this.form.nickname,
          postcode: this.form.postcode,
          province: this.form.province,
          qq: this.form.qq,
          sex: this.form.sex,
          wechat: this.form.wechat,
          wechatImg: this.form.wechatImg,
        };
        const { code, result } = await userEdit(params);
        this.loading = false;
        if (code === 200 && result) {
          this.$Message.success("修改成功");
          this.MUT_USER_PART_INFO(params);
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    // 获取地区信息
    async req_getRegionList() {
      try {
        const { code, data } = await getRegionList();
        if (code === 200) {
          this.MTU_REGION_LIST(data);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.section {
  background-color: #fff;
  border-radius: 8px;
  padding: 50px;
  .row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .name {
      min-width: 80px;
      font-size: 14px;
      line-height: 20px;
      color: #333;
    }
    .name.required {
      &::before {
        content: "*";
        color: #ed1d33;
        margin-right: 5px;
      }
    }
    .label {
      font-size: 14px;
      line-height: 20px;
      color: #333;
    }
  }
  .col-group {
    display: flex;
    .col {
      min-width: 300px;
      margin-bottom: 20px;
      &:last-child {
        margin-left: 60px;
      }
      .name {
        min-width: 80px;
        font-size: 14px;
        line-height: 20px;
        color: #333;
        margin-bottom: 20px;
      }
      .name.required {
        &::before {
          content: "*";
          color: #ed1d33;
          margin-right: 5px;
        }
      }
      .label {
        font-size: 14px;
        line-height: 20px;
        color: #333;
      }
    }
  }
  .t-row {
    display: flex;
    align-items: center;
  }
}
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
/deep/.upload {
  .ivu-upload-drag {
    border: none;
  }
}
</style>
